// src/api/investigationsAdminService.ts
import apiClient from './config';       // ← el mismo helper que usas en chatInit

export type InvestigationStatus =
  | 'accepted'
  | 'rejected'
  | 'under_review'
  | 'deleted_by_user';

export interface InvestigationUser {
  id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  sienaguard_tokens_balance: number;
  created_at: string;
}

export interface InvestigationItem {
  id: string;
  company_name: string;
  comments: string | null;
  created_at: string;
  status: InvestigationStatus;
  domains: string[];
  urls: string[];
  user: InvestigationUser | null;
}

export interface InvestigationList {
  total: number;
  items: InvestigationItem[];
}

export const getInvestigations = async (
  status: InvestigationStatus,
  page = 0,
  pageSize = 50
): Promise<InvestigationList> => {
  try {
    const res = await apiClient.get(`/admin/investigations/${status}`, {
      params: { limit: pageSize, offset: page * pageSize }
    });
    return res.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.detail ?? 'Error fetching investigations');
  }
};


export const actOnInvestigation = async (
    id: string,
    action: 'accept' | 'reject',
    adminComment: string
  ) => {
    const res = await apiClient.patch(`/admin/investigations/${id}`, {
      action,
      admin_comment: adminComment,
    });
    return res.data;
  };